import script from "./DeleteAccountReason.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountReason.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountReason.vue?vue&type=style&index=0&id=2975edce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2975edce"]])

export default __exports__